// M7 — Audit Action Types
// Central, immutable audit log for all significant system events.

export const AUDIT_ACTIONS = {
    // Auth
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILED: 'LOGIN_FAILED',
    LOGIN_DENIED_DOMAIN: 'LOGIN_DENIED_DOMAIN', // email domain not in an allowed company
    LOGOUT: 'LOGOUT',
    LOGIN_AS: 'LOGIN_AS', // impersonation start
    LOGIN_AS_END: 'LOGIN_AS_END', // impersonation end

    // Profile changes
    EMPLOYEE_CREATED: 'EMPLOYEE_CREATED',
    EMPLOYEE_UPDATED: 'EMPLOYEE_UPDATED', // metadata: { field, old_value, new_value }
    EMPLOYEE_STATUS_CHANGED: 'EMPLOYEE_STATUS_CHANGED',
    // Leaving details recorded via the "Lõpeta töösuhe" flow (TASK-403).
    EMPLOYEE_OFFBOARDED: 'EMPLOYEE_OFFBOARDED',

    // Compensation
    COMPENSATION_CREATED: 'COMPENSATION_CREATED',
    COMPENSATION_UPDATED: 'COMPENSATION_UPDATED',
    COMPENSATION_DELETED: 'COMPENSATION_DELETED',
    COMPENSATION_REVEALED: 'COMPENSATION_REVEALED', // admin clicked to unmask salary figures
    COMPENSATION_ACTIVATED: 'COMPENSATION_ACTIVATED', // system: a future-dated comp record became active

    // Employment records
    EMPLOYMENT_RECORD_DELETED: 'EMPLOYMENT_RECORD_DELETED',

    // Contracts (M3.3 — probation_end_date / contract_type changes)
    EMPLOYEE_CONTRACT_CREATED: 'EMPLOYEE_CONTRACT_CREATED',
    EMPLOYEE_CONTRACT_UPDATED: 'EMPLOYEE_CONTRACT_UPDATED',
    EMPLOYEE_CONTRACT_PROBATION_EXTENDED: 'EMPLOYEE_CONTRACT_PROBATION_EXTENDED',

    // Emergency contacts (profile)
    EMERGENCY_CONTACT_ADDED: 'EMERGENCY_CONTACT_ADDED',
    EMERGENCY_CONTACT_REMOVED: 'EMERGENCY_CONTACT_REMOVED',
    EMERGENCY_CONTACT_UPDATED: 'EMERGENCY_CONTACT_UPDATED',

    // Experiences ("Kogemused" repeater, TASK-300)
    EXPERIENCE_ADDED: 'EXPERIENCE_ADDED',
    EXPERIENCE_UPDATED: 'EXPERIENCE_UPDATED',
    EXPERIENCE_REMOVED: 'EXPERIENCE_REMOVED',

    // Employee documents (profile)
    DOCUMENT_UPLOADED: 'DOCUMENT_UPLOADED',
    DOCUMENT_UPDATED: 'DOCUMENT_UPDATED',
    DOCUMENT_DELETED: 'DOCUMENT_DELETED',

    // Workflow tasks (M3 — Tasks page)
    WORKFLOW_TASK_CREATED: 'WORKFLOW_TASK_CREATED', // system: probation-review task generated by cron
    WORKFLOW_TASK_COMPLETED: 'WORKFLOW_TASK_COMPLETED',
    WORKFLOW_TASK_DISMISSED: 'WORKFLOW_TASK_DISMISSED',

    // Time-off
    TIME_OFF_REQUESTED: 'TIME_OFF_REQUESTED',
    TIME_OFF_APPROVED: 'TIME_OFF_APPROVED',
    TIME_OFF_REJECTED: 'TIME_OFF_REJECTED',
    TIME_OFF_CANCELLED: 'TIME_OFF_CANCELLED',
    TIME_OFF_CANCEL_REQUESTED: 'TIME_OFF_CANCEL_REQUESTED', // owner asked to delete a taken absence (TASK-402)
    TIME_OFF_CANCEL_REJECTED: 'TIME_OFF_CANCEL_REJECTED', // manager declined the deletion; the absence stands
    TIME_OFF_EDITED: 'TIME_OFF_EDITED',
    LEAVE_LEDGER_ADJUSTED: 'LEAVE_LEDGER_ADJUSTED',
    LEAVE_ACCRUED: 'LEAVE_ACCRUED', // system: accrual cron granted entitlement (metadata: { accrual_kind, ... })
    LEAVE_EXPIRED: 'LEAVE_EXPIRED', // system: expiration cron retired unused buckets

    // System settings
    POLICY_CREATED: 'POLICY_CREATED',
    POLICY_UPDATED: 'POLICY_UPDATED',

    // RBAC: Roles (Plan 3 — configurator)
    ROLE_CREATED: 'ROLE_CREATED',
    ROLE_UPDATED: 'ROLE_UPDATED',
    ROLE_DELETED: 'ROLE_DELETED',
    ROLE_MEMBER_ADDED: 'ROLE_MEMBER_ADDED',
    ROLE_MEMBER_REMOVED: 'ROLE_MEMBER_REMOVED',

    // Export (data export)
    EXPORT_REPORT: 'EXPORT_REPORT', // metadata: { report_type, filters, format, row_count }
    EXPORT_EMPLOYEE_LIST: 'EXPORT_EMPLOYEE_LIST',

    // M9: Settings
    SETTINGS_UPDATED: 'SETTINGS_UPDATED', // metadata: { action, ... }

    // Integrations (per-user token lifecycle)
    INTEGRATION_CONNECTED: 'INTEGRATION_CONNECTED', // metadata: { provider }
    INTEGRATION_DISCONNECTED: 'INTEGRATION_DISCONNECTED', // metadata: { provider }
} as const

export type AuditAction = (typeof AUDIT_ACTIONS)[keyof typeof AUDIT_ACTIONS]

export const ALL_AUDIT_ACTIONS = Object.values(AUDIT_ACTIONS)
